<template>
  <div class="tool">
    <form-wizard
      title=''
      subtitle=''
      :nextButtonText='$t("tool.wizard.general.nextButton")'
      :backButtonText='$t("tool.wizard.general.backButton")'
      :finishButtonText='$t("tool.wizard.general.finishButton")'
      @on-complete='onComplete'
    >
    <!-------------- Plus -------------->
      <tab-content :title='$t("tool.wizard.plus.title")'>
        <h4 class="center-text">{{ $t("tool.wizard.plus.subtitle") }}</h4>
        <img src="../assets/moneyin.jpg" class="step-image"/>
        <div>
          <p>{{ $t("tool.wizard.plus.incomeQuestion") }}</p>
          <span :class="$i18n.locale === 'nl' ? 'input-symbol-euro' : 'input-symbol-dollar'">
            <input v-model="income" type="number" min="0"/>
          </span>
        </div>
        <div>
          <p>{{ $t("tool.wizard.plus.salaryDateQuestion") }}</p>
          <input v-model="salaryDate" type="number" min="1" max="31"/>
        </div>
      </tab-content>
    <!---------------------------->

    <!-------------- Min -------------->
      <tab-content :title='$t("tool.wizard.min.title")'>
        <h4 class="center-text">{{ $t("tool.wizard.min.subtitle") }}</h4>
        <img src="../assets/moneyout.jpg" class="step-image"/>
        <div>
          <p>{{ $t("tool.wizard.min.costsQuestion") }}</p>
          <span :class="$i18n.locale === 'nl' ? 'input-symbol-euro' : 'input-symbol-dollar'">
            <input v-model="costs" type="number" min="0" :max="income"/>
          </span>
        </div>
      </tab-content>
    <!---------------------------->

    <!-------------- Toekomst -------------->
      <tab-content :title='$t("tool.wizard.future.title")'>
        <h4 class="center-text">{{ $t("tool.wizard.future.subtitle") }}</h4>
        <img src="../assets/beachdrink2.jpg" class="step-image"/>
        <div>
          <p>{{ $t("tool.wizard.future.savingQuestion", { amount: income - costs }) }}</p>
          <span :class="$i18n.locale === 'nl' ? 'input-symbol-euro' : 'input-symbol-dollar'">
            <input v-model="saving" type="number" min="0" :max="(income - costs)"/>
          </span>
        </div>

        <div>
          <p>{{ $t("tool.wizard.future.investingQuestion") }}</p>
          <div class="button" v-if="!investing" @click="toggleInvesting">
            <p>{{ $t("tool.wizard.future.investingButtonYes") }}</p>
            <i class="fas fa-chevron-down"></i>
          </div>
          <div class="button" v-else @click="toggleInvesting">
            <p>{{ $t("tool.wizard.future.investingButtonNo") }}</p>
            <i class="fas fa-chevron-up"></i>
          </div>
        </div>

        <collapse-transition>
          <div v-show="this.investing">
            <p v-html='$t("tool.wizard.future.investing.intro")'/>
            <a :href='$t("tool.wizard.future.investing.indexFundLink")'>
              {{ $t("tool.wizard.future.investing.readMoreIndex") }}
            </a>

            <div style="display: flex; width: 100%; justify-content: space-between">
              <p> < {{ $t("tool.wizard.future.investing.sliderSaving") }}</p>
              <p>{{ $t("tool.wizard.future.investing.sliderInvesting") }} > </p>
            </div>
            <input style="width: 100%" type="range" v-model="investmentRatio" step="10"/>
            <p class="center-text">
              {{ 100 - investmentRatio }}% {{ $t("tool.wizard.future.investing.saving") }},
               {{ investmentRatio }}% {{ $t("tool.wizard.future.investing.investing") }}
            </p>
          
            <div class="button" @click="toggleAdvancedInvesting">
              <p>{{ $t("tool.wizard.future.investing.advancedButton") }}</p>
              <i class="fas fa-cog"></i>
            </div>
            <collapse-transition>
              <div v-show="this.advancedInvesting" style="margin: 20px 0px;">
                <div style="display: flex; justify-content: space-between;">
                  <p>{{ $t("tool.wizard.future.investing.expectedReturnRateQuestion") }}</p>
                  <input v-model="expectedReturnRate" type="number" min="0" max="10"/>
                </div>
              </div>
            </collapse-transition>
          
          </div>
        </collapse-transition>

        <div>
          <p>{{ $t("tool.wizard.future.graphExplainer") }}</p>
          
          <line-chart 
            :min="0" 
            :max="saving * 1800" 
            :colors="['#42b983']" 
            :ytitle='$t("tool.wizard.future.totalSaved")'
            :data="chartData" 
            :prefix='$t("tool.wizard.future.graphPrefix")'
            :decimal='$t("tool.wizard.future.graphDecimal")'
            :thousands='$t("tool.wizard.future.graphThousands")'
          />

          <p v-if="this.investing" v-html='$t("tool.wizard.future.graphCommentInvesting")' class="center-text"/>
          <p v-else v-html='$t("tool.wizard.future.graphCommentSaving")' class="center-text"/>

        </div>
      </tab-content>
    <!---------------------------->

    </form-wizard>
  </div>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { CollapseTransition } from "@ivanv/vue-collapse-transition"

export default {
  name: 'Tool',
  components: {
    FormWizard,
    TabContent,
    CollapseTransition
  },
  data: () => {
    return {
      income: null,
      costs: null,
      saving: null,
      salaryDate: null,
      investing: false,
      advancedInvesting: false,
      investmentRatio: 0,
      expectedReturnRate: 8,
    }
  },
  methods: {
    onComplete () {
      if(this.income, this.costs, this.saving, this.salaryDate) {
        this.$router.push({ 
          name:'Advice',
          params: { 
            income: this.income,
            salaryDate: this.salaryDate,
            costs: this.costs,
            saving: this.saving,
            investing: this.investing,
            investmentRatio: this.investmentRatio,
          }
        });
      } else {
        alert('Je hebt nog niet alles ingevuld')
      }
      
    },
    toggleInvesting () {
      this.investing = !this.investing
      if (!this.investing) this.investmentRatio = 0
    },
    toggleAdvancedInvesting () {
      this.advancedInvesting = !this.advancedInvesting
    }
  },
  computed: {
    chartData () {
      const monthlyContribution = this.saving
      const interestRate = (this.expectedReturnRate / 100) * (this.investmentRatio / 100)    //afhankelijk van ratio tussen sparen (0%) en beleggen (8%)
      const yearsToCalculate = [1, 5, 10, 15, 20, 25, 30]

      let chartValues = yearsToCalculate.map((yearValue) => {
        return {
          [yearValue + " jaar"]: compoundedValue(monthlyContribution, interestRate, yearValue)
        }
      })

      chartValues = Object.assign( ...chartValues )

      function compoundedValue(saving, annualInterest, years) {
        return (function compound(balanceAtPeriodBeginning, amountDepositedPerMonth, coeff, pow, interestOnly, compoundMonthly, basicRate, cap, initialAmount) {
    return pow>=1/12 // are we on base case or inductive case?
    ? compound(
        (balanceAtPeriodBeginning + amountDepositedPerMonth * (compoundMonthly || 12)) // plus amount deposited
        + Math.min((balanceAtPeriodBeginning + amountDepositedPerMonth * (compoundMonthly || 12)), cap || Infinity) // interest applied is upon capped contents
        * (((!compoundMonthly*coeff || Math.pow(coeff, 1/12)) // has compounding applied
            -1)
            * (1-(basicRate||0)) // with basic rate of tax deducted
                +1)
        - Math.min((balanceAtPeriodBeginning + amountDepositedPerMonth * (compoundMonthly || 12)), cap || Infinity),
        amountDepositedPerMonth,
        coeff,
        pow-(compoundMonthly || 12)/12,
        interestOnly,
        compoundMonthly,
        basicRate,
        cap,
        typeof initialAmount === 'undefined' ? balanceAtPeriodBeginning : initialAmount
        )
    -(interestOnly && amountDepositedPerMonth * (compoundMonthly || 12))
    : balanceAtPeriodBeginning - (interestOnly
                                ? initialAmount
                                : 0)
        })(
        0,    // balance with which your account begins (in euro/dollar)
        saving,  // amount you expect to deposit monthly (in euro/dollar)
        1 + annualInterest, // annual interest (i.e. 2.1% = 1.021) or AER
        years,    // over how many years you are depositing
        false, // show just the interest earned (i.e. subtract amount you deposit)
        true,// whether to compound monthly (true) or annually (false). 
        0,  // basic rate tax
        // 200000000000  // maximum amount upon which interest can be earned
        )
        .toFixed(2);
      }

      return chartValues
    }
  }
}
</script>

<style scoped lang="scss">
.tool {
  max-width: 550px;
  margin: 0 auto;
}

.button {
  cursor: pointer;
  padding: 5px 20px;
  background: #6ea1ff;
  max-width: 200px;
  margin: 0 auto;
  border-radius: 8px;
  display: flex;
  justify-content: space-around;
  color: white;

  i {
    margin-top: 18px;
    margin-left: 10px;
  }
}

.step-image {
  width: 100%;
  border-radius: 4px;
}

/deep/ .stepTitle {
  margin-top: 10px;
}

p {
  text-align: left;
}

input {
    text-align: center;
    padding: 10px;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid lightgrey;
}

 .input-symbol-euro {
     position: relative;
 }
 .input-symbol-euro input {
     padding-left:18px;
 }
 .input-symbol-euro:before {
     position: absolute;
     top: 0;
     content:"€";
     left: 5px;
 }

 .input-symbol-dollar {
     position: relative;
 }
 .input-symbol-dollar input {
     padding-left:18px;
 }
 .input-symbol-dollar:before {
     position: absolute;
     top: 0;
     content:"$";
     left: 5px;
 }

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.center-text {
  text-align: center;
}
</style>
